var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    fill: "#FFF4ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    stroke: "#FCE9DE",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19751 5.50894C8.89345 5.18066 8.46876 4.99988 8.00001 4.99988C7.52876 4.99988 7.10267 5.17957 6.80001 5.50582C6.49408 5.83566 6.34502 6.28394 6.38002 6.768C6.44939 7.723 7.17611 8.49988 8.00001 8.49988C8.82392 8.49988 9.54939 7.72316 9.61986 6.76831C9.65533 6.28863 9.50533 5.84128 9.19751 5.50894Z",
    fill: "#F1935C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7501 11.9995H5.25009C5.1781 12.0004 5.10681 11.9853 5.0414 11.9552C4.97599 11.9252 4.91811 11.8809 4.87196 11.8256C4.7704 11.7042 4.72946 11.5384 4.75978 11.3708C4.89165 10.6392 5.30321 10.0247 5.95009 9.59326C6.52478 9.21029 7.25274 8.99951 8.00009 8.99951C8.74743 8.99951 9.4754 9.21045 10.0501 9.59326C10.697 10.0245 11.1085 10.639 11.2404 11.3706C11.2707 11.5383 11.2298 11.704 11.1282 11.8254C11.0821 11.8807 11.0242 11.9251 10.9588 11.9552C10.8934 11.9853 10.8221 12.0004 10.7501 11.9995Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.fe9b4f516f8e0d6826526477c9598038.svg";
export { ForwardRef as ReactComponent };